var linkBg = "/static/c4d5a90cf4478ae0.png";

export { linkBg as default };
//# sourceMappingURL=link-bg-2.png.js.map
